import { isCheckingUrl } from './businessBankingRouteUtil';
import { BSA_ROUTES, BCA_ROUTES } from '../constants';

const accountDetailsRouteMatcher = (accountsRoute) =>
  new RegExp(`${accountsRoute}/(.*)/account-details`);

const getAccountNumberFromPath = (pathname, accountToken = null) => {
  const isChecking = isCheckingUrl(pathname);
  const route = isChecking ? BCA_ROUTES : BSA_ROUTES;

  if (!pathname.startsWith(route.ACCOUNTS)) {
    return null;
  }
  if (pathname.startsWith(route.ACCOUNT_MANAGEMENT)) {
    return null;
  }
  if (pathname.startsWith(route?.OPEN_NEW_ACCOUNT)) {
    return null;
  }
  if (accountDetailsRouteMatcher(route.ACCOUNTS).test(pathname)) {
    return null;
  }
  // Prefer the route param token first: router params are decoded (inverse of encodeURIComponent used on redirects),
  // while slicing `pathname` can leave encoded characters and is only a fallback when params are unavailable.
  return accountToken || pathname.slice(route.ACCOUNTS.length + 1);
};

export default getAccountNumberFromPath;
